const steps = [
  {
    num: '01',
    title: 'QRコードを店舗に設置',
    desc: 'レジ横・テーブル・ショーウィンドウなど集客しやすい場所に専用QRコードを設置します。デザインはブランドに合わせてカスタマイズ可能です。',
    img: 'https://public.readdy.ai/ai/img_res/d98ffb66569fee9a3eb9bdcdb39ce3f0.jpg',
  },
  {
    num: '02',
    title: '来店客がスキャン',
    desc: '来店されたお客様がスマートフォンでQRコードをスキャン。特別クーポン・限定情報などのインセンティブで自然なスキャン率アップを実現します。',
    img: 'https://readdy.ai/api/search-image?query=customer%20scanning%20QR%20code%20with%20smartphone%20in%20retail%20store%2C%20close%20up%20of%20hands%20holding%20phone%2C%20modern%20shopping%20experience%2C%20bright%20clean%20environment&width=500&height=360&seq=qr002&orientation=landscape',
  },
  {
    num: '03',
    title: '商品・サービスを購入',
    desc: 'スキャン後、アフィリエイトリンク付きページへ誘導。オンライン購入・会員登録・資料請求など設定した成果地点への行動を促します。',
    img: 'https://readdy.ai/api/search-image?query=person%20using%20smartphone%20to%20shop%20online%2C%20mobile%20ecommerce%20purchase%2C%20digital%20payment%20success%20screen%2C%20clean%20white%20background%20lifestyle&width=500&height=360&seq=qr003&orientation=landscape',
  },
  {
    num: '04',
    title: '報酬が自動で発生',
    desc: '成果が確定すると管理画面に自動反映。スキャン元・時間帯・エリア別など詳細なレポートで効果検証も簡単です。',
    img: 'https://readdy.ai/api/search-image?query=business%20analytics%20dashboard%20on%20laptop%20screen%20showing%20revenue%20charts%20and%20graphs%2C%20clean%20modern%20office%20desk%2C%20professional%20data%20visualization&width=500&height=360&seq=qr004&orientation=landscape',
  },
];

export default function QRUsage() {
  return (
    <section id="qr-usage" className="py-24 bg-gray-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="text-red-500 text-sm font-bold tracking-widest uppercase">How to Use</span>
          <h2 className="text-4xl font-black text-gray-900 mt-3 mb-4">QRコード活用方法</h2>
          <p className="text-gray-500 text-base max-w-xl mx-auto leading-relaxed">
            4つのステップで、店舗QRコードアフィリエイトが動き始めます。
          </p>
        </div>

        <div className="flex flex-col gap-12">
          {steps.map((step, i) => (
            <div
              key={i}
              className={`flex flex-col ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center gap-10 bg-white rounded-xl overflow-hidden`}
            >
              <div className="w-full md:w-1/2 h-64 md:h-72 overflow-hidden flex-shrink-0">
                <img
                  src={step.img}
                  alt={step.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 px-8 py-8 md:py-0">
                <div className="text-red-500 text-5xl font-black mb-4 leading-none">{step.num}</div>
                <h3 className="text-gray-900 text-xl font-bold mb-3">{step.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
